/**
 * 会员管理系统 - 套餐管理 API
 *
 * 提供套餐的 CRUD 操作
 */

import httpRequest from '@/utils/api'
import type {
  Plan,
  CreatePlanRequest,
  UpdatePlanRequest,
  PlanListResponseData,
  SyncQuotasResponseData,
} from '@/types/membership/plan'

enum API {
  plans = '/admin/plans',
}

/**
 * 获取所有套餐
 *
 * @returns 套餐列表响应
 */
export const getAllPlansAPI = () => {
  return httpRequest.get<PlanListResponseData>({
    url: API.plans,
  })
}

/**
 * 创建套餐
 *
 * @param data 创建套餐请求数据
 * @returns 套餐详情响应
 */
export const createPlanAPI = (data: CreatePlanRequest) => {
  return httpRequest.post<Plan>({
    url: API.plans,
    data,
  })
}

/**
 * 更新套餐
 *
 * @param planId 套餐 ID
 * @param data 更新套餐请求数据
 * @returns 套餐详情响应
 */
export const updatePlanAPI = (planId: number, data: UpdatePlanRequest) => {
  return httpRequest.put<Plan>({
    url: `${API.plans}/${planId}`,
    data,
  })
}

/**
 * 删除套餐
 *
 * @param planId 套餐 ID
 * @returns 删除响应
 */
export const deletePlanAPI = (planId: number) => {
  return httpRequest.delete<{ message: string }>({
    url: `${API.plans}/${planId}`,
  })
}

/**
 * 同步套餐配额到现有用户
 *
 * 将套餐的最新功能配额同步到所有活跃订阅用户
 *
 * @param planId 套餐 ID
 * @returns 同步结果
 */
export const syncPlanQuotasAPI = (planId: number) => {
  return httpRequest.post<SyncQuotasResponseData>({
    url: `${API.plans}/${planId}/sync-quotas`,
  })
}

